import { GoDashboard } from "react-icons/go";
// import { IoIosShuffle } from "react-icons/io";
import { MdShare, MdPersonAdd, MdDomain } from "react-icons/md";
import { permissionsConstants } from "../../../constants/permission.constants";

const { VIEW_USERS, VIEW_INSTITUTIONS, VIEW_DISBURSEMENT } = permissionsConstants;

export const menuConfig = {
    menus: [
        {
            categoryBlock: true,
            key: "dashboard",
            title: "Dashboard",
            icon: GoDashboard,
            path: "/dashboard",
            permissions: [],
        },
        {
            title: "User Management",
            key: "user-management",
            path: "/users",
            permissions: [VIEW_USERS],
            icon: MdPersonAdd,
        },
        {
            title: "Institutions",
            key: "institution",
            path: "/institution",
            permissions: [VIEW_INSTITUTIONS],
            icon: MdDomain,
        },
        {
            title: "Disbursement",
            key: "disbursement",
            path: "/disbursement",
            permissions: [VIEW_DISBURSEMENT],
            icon: MdShare,
        },
    ],
};
